<template>
  <custom-dialog
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    width="1200px"
    class="case-order-select-device-dialog"
    :appendToBody="true"
  >
    <div class="dialog-body">
      <div class="search-hd">
        <el-form :inline="true" @submit.prevent.native>
          <el-form-item style="float: right;">
            <search-input
              :placeholder="$t('asm_select_device_dialog.ji_shen_hao')"
              @search="onSearch"
              @enter="onSearch"
              v-model="formSearch.search"
            ></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table
          ref="table"
          height="400px"
          :data="tableList"
          :tableCode="tableCode"
          type="checkbox"
          @select="onSelect"
          v-model="selectedData"
        ></custom-table>
      </div>
      <!-- 分页 -->
      <div class="table-page">
        <custom-page
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
        ></custom-page>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="closeDialog">{{$t('Common.com_cancel')}}</el-button>
      <el-button
        :disabled="!selectedData.length"
        type="primary"
        @click="onConfirm"
      >{{$t('Common.com_confirm')}}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {},
  data() {
    return {
      tableCode: 'case_order_select_device',
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,
      },
      selectedData: [],
      tableList: [],
      totalRows: 0,
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    onConfirm() {
      this.closeDialog();
      this.$emit('confirm', this.selectedData);
    },
    closeDialog() {
      this.visible = false;
    },
    onSelect(selection, row) {
      setTimeout(() => {
        this.tableList.forEach((_) => {
          if (_.deviceId !== row.deviceId) {
            this.$refs.table.$refs.tb1.toggleRowSelection(_, false);
          }
        });
      }, 100);
    },
    getTableList() {
      this.$getJSON(apis.DeviceBizScStockPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    onSearch() {
      this.getTableList();
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;

      this.getTableList();
    },
  },
  created() { },
  mounted() {
    this.getTableList();
  },
};
</script>

<style lang="scss" scoped>
.case-order-select-device-dialog {
  /deep/ .el-table__fixed-header-wrapper .el-checkbox {
    //找到表头那一行，然后把里面的复选框隐藏掉
    display: none;
  }
}
</style>
